export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/mongo.c7d5e7e.svg";